// Explicit public routes only. Keep this versioned measurement independent of other events.
export const ENTRY_EVENT = 'H0189 Public Entry';
export const PUBLIC_ENTRY_PATHS = Object.freeze(["/", "/about", "/blog", "/blog/15-minute-online-drawing-game", "/blog/15-minute-team-trivia", "/blog/online-team-game-20-people", "/blog/online-team-games-for-10-people", "/blog/online-team-games-for-4-people", "/blog/team-drawing-games", "/blog/virtual-icebreaker-games", "/blog/weekly-team-game-rotation", "/contact", "/employee-appreciation-week-games", "/game/button-factory", "/game/codenames", "/game/cosel", "/game/draw-battle", "/game/emoji-story", "/game/escape-room", "/game/fake-artist", "/game/faker", "/game/hot-seat", "/game/scribble", "/game/speed-meet", "/game/starts-with-j", "/game/taboo", "/game/team-trvia", "/game/this-or-that", "/game/trivia", "/game/two-truths-one-lie", "/game/type-racer", "/landing", "/pricing", "/privacy", "/team-game-cost-calculator", "/termsofservice"]);
const paths = new Set(PUBLIC_ENTRY_PATHS);
export const productionHost = host => ['teambridge.app', 'www.teambridge.app'].includes(host);
export function publicEntryPath(path, user) {
  return paths.has(path) && !(path === '/' && user?.username);
}
export function primaryLanguage(value) {
  if (typeof value !== 'string' || !value || value.length > 64) return 'unknown';
  try {
    const tag = Intl.getCanonicalLocales(value)[0];
    const primary = tag.split('-')[0].toLowerCase();
    return /^[a-z]{2,8}$/.test(primary) ? primary : 'unknown';
  } catch (_) {
    return 'unknown';
  }
}
export function createEntryObserver() {
  const sent = new Set();
  return ({
    loaded,
    user,
    path,
    hostname,
    language,
    operatorTest = false
  }, track) => {
    if (!loaded || !user?._id || !productionHost(hostname) || !publicEntryPath(path, user)) return false;
    const actor = String(user._id);
    if (sent.has(actor)) return false;
    sent.add(actor); // At most one attempt per actor/document; optional analytics never retry navigation.
    try {
      Promise.resolve(track(ENTRY_EVENT, {
        entry_path: path,
        browser_language: primaryLanguage(language),
        operator_test: operatorTest === true,
        schema_version: 1
      })).catch(() => {});
    } catch (_) {/* Optional measurement must not affect navigation. */}
    return true;
  };
}
export function sourceEntryProperties(req, now = new Date()) {
  const body = req.body;
  // Do not trust X-Forwarded-Host or a client-supplied production_host.
  const hostname = req.get('host');
  if (!productionHost(hostname) || !req.user?._id || !body || body.schema_version !== 1 || typeof body.operator_test !== 'boolean' || !publicEntryPath(body.entry_path, req.user) || typeof body.browser_language !== 'string' || body.browser_language !== 'unknown' && primaryLanguage(body.browser_language) !== body.browser_language) return null;
  return {
    distinct_id: String(req.user._id),
    source_utc: now.toISOString(),
    production_host: hostname,
    entry_path: body.entry_path,
    browser_language: body.browser_language,
    operator_test: body.operator_test,
    schema_version: 1
  };
}